import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EmptySearch from '../assets/images/EmptySearch.svg'

export default function EmptySearchResults() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        py: 4
      }}
    >
      <img
        src={EmptySearch}
        alt='Empty List'
        style={{
          width: '12.5rem',
          height: '12.5rem',
          objectFit: 'contain'
        }}
      />
      <Typography variant='body1' fontWeight='bold'>
        {t('common.empty_search.title')}
      </Typography>
      <Typography variant='body1'>
        {t('common.empty_search.description')}
      </Typography>
    </Box>
  )
}
